import { req } from '../../@api/request';

const baseURL = `${'https://back.transfarmer.kr'}`;

export const request = new Request(baseURL);

const fetchData = async (url: string) => {
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};

export default class TermsService {
  static version = async (type: string) => {
    let url = baseURL + `/terms/version?type=${type}`;
    const result = await fetchData(url);
    return result;
  };
  static terms = async (version: number, type: string) => {
    let url = baseURL + `/terms/${version}?type=${type}`;
    const result = await fetchData(url);
    return result;
  };
}
